export var SELECTED_TERMS = {
  TERMS: 'TERMS',
  PRIVACY: 'PRIVACY'
};